import { IPaths } from '../../types/types';
import { RouteEnum } from './routeEnum';

export const paths: IPaths = {
  main: '/m',
  dashboard: '/dashboard',
  subscription: '/subscription',
  settings: '/settings',
  settingsProfile: '/settings/profile',
  users: '/users',
  mentors: '/mentors',
  roles: '/roles',
  permissions: '/permissions',
  tenantList: '/tenant-list/',
  logs: '/logs',
  reports: '/reports',
  orders: '/orders',
};

export const APP_ROLES = ['mentor', 'student'] as const;
export type AppRole = (typeof APP_ROLES)[number];

export const roles = {
  NONE: 'none',
  MENTOR: 'mentor',
  STUDENT: 'student',
} as const;

export type StoredAppRole = AppRole | typeof roles.NONE;

export function isAppRole(value: string): value is AppRole {
  return (APP_ROLES as readonly string[]).includes(value);
}

export function rolePath(role: string, pagePath: string): string {
  if (!role || role === roles.NONE || !isAppRole(role)) return pagePath;
  if (pagePath === '/') return `/${role}`;
  return `/${role}${pagePath}`;
}

export function toRolePage(role: string, pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  if (!segments.length) {
    return rolePath(role, paths.dashboard);
  }
  if (isAppRole(segments[0])) {
    const page = `/${segments.slice(1).join('/')}`;
    return rolePath(role, page === '/' ? paths.dashboard : page);
  }
  return rolePath(role, pathname.startsWith('/') ? pathname : `/${pathname}`);
}

export const defaultRoutesByRole: Record<StoredAppRole, string> = {
  none: RouteEnum.SIGN_IN,
  mentor: rolePath(roles.MENTOR, paths.dashboard),
  student: rolePath(roles.STUDENT, paths.dashboard),
};
